import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 14.295L7.41 15.705L12 11.125L16.59 15.705L18 14.295L12 8.295L6 14.295Z",
		fill: "#696F88"
	})
});
export default SvgChevronUp;
